import styled from '@emotion/styled'

const colors = {
  'white': '#ffffff',
  'blue': '#002a45',
  'orange': '#ffb400',
  'greyblue': '#5c7ea4',
  'grey': '#808080',
  'lightgrey': '#f4f4f4',
  'black': '#000000'
}

export const LogosContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 20rem 0;

  @-webkit-keyframes slidein {
    from { transform: translateY(0%); }
    to { transform: translateY(10%); }
  }
  @-moz-keyframes slidein {
    from { transform: translateY(0%); }
    to { transform: translateY(10%); }
  }
   @-o-keyframes slidein {
    from { transform: translateY(0%); }
    to { transform: translateY(10%); }
  }
    @keyframes slidein {
    from { transform: translateY(0%); }
    to { transform: translateY(10%); }
  }
`;

export const Logo = styled.figure`
  position: absolute;
  border-radius: 50%;
  overflow: hidden;

  background: ${props => colors[props.color]} url(${props => props.img});
  background-size: ${props => props.size ? props.size : 80}%;
  background-position: center center;
  background-repeat: no-repeat;
  box-shadow: 0 24px 32px 0 rgba(0,0,0,${props => props.shadow}), 0 8px 32px 0 rgba(0,0,0,${props => props.shadow});
  background-blend-mode: ${props => props.blend ? props.blend : 'normal'};
  top: ${props => props.top}px;
  left: ${props => props.left}px;


  @media (max-width: ${props => props.theme.breakpoints.m}) {
    top: ${props => props.top * (60 / 100)}px;
    left: ${props => props.left * (60 / 100)}px;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    top: ${props => props.top * (60 / 100)}px;
    left: ${props => props.left * (60 / 100)}px;
  }

  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-name: slidein;
  -webkit-animation-duration: ${props => props.animationTime + 3}s;
  -webkit-animation-direction: alternate;
  -webkit-animation-iteration-count: infinite;

  -moz-animation-timing-function: ease-in-out;
  -moz-animation-name: slidein;
  -moz-animation-duration: ${props => props.animationTime + 3}s;
  -moz-animation-direction: alternate;
  -moz-animation-iteration-count: infinite;

  -o-animation-timing-function: ease-in-out;
  -o-animation-name: slidein;
  -o-animation-duration: ${props => props.animationTime + 3}s;
  -o-animation-direction: alternate;
  -o-animation-iteration-count: infinite;

  animation-timing-function: ease-in-out;
  animation-name: slidein;
  animation-duration: ${props => props.animationTime + 3}s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
`;

export const LogoLarge = styled(Logo)`
  width: 15rem;
  height: 15rem;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    width: 10rem;
    height: 10rem;
  }
`;
export const LogoMedium = styled(Logo)`
  width: 12rem;
  height: 12rem;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    width: 8rem;
    height: 8rem;
  }
`;
export const LogoSmall = styled(Logo)`
  width: 10rem;
  height: 10rem;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    width: 5rem;
    height: 5rem;
  }
`;
